










































import { Component, Vue } from 'vue-property-decorator';
import AuthModule from '@/store/modules/auth.module';
import { RouteName } from '@/utils/constants';
import TaftImageAnimated from '@/components/base-layout/TaftImageAnimated.vue';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    TaftImageAnimated,
  },
})
export default class UnauthorizedView extends Vue {
  authStore = getModule(AuthModule, this.$store);
  showHomeButton = true;

  mounted() {
    this.showHomeButton = !this.authStore.isDeviceOnlyUser;
  }

  goToHome() {
    if (this.authStore.isAuthenticated) {
      if (this.authStore.isIdirUser) {
        this.$router.push(`/${RouteName.Ministry}`);
      } else {
        this.$router.push(`/${RouteName.Main}`);
      }
    } else {
      this.$router.push('/');
    }
  }

  logout() {
    if (this.authStore.isAuthenticated) {
      this.$router.push('/logout');
    } else {
      this.$router.push('/');
    }
  }
}
